<template>
    <div>
        <select name="destination" id="destinationFilter" ref="regionSelector" class="py-3 mb-5 w-full  bg-white border-b-2 border-gray-500" @change="redirectToOverview">
            <option value="" selected disabled>{{ placeholderText }}</option>
            <option v-for="region in regions" :value="region.slug">{{ region.name }}</option>
        </select>

        <button
           class="py-2 px-2 w-full text-sm text-white rounded bg-orange-500 hover:bg-orange-600 md:text-base lg:text-lg"
           :class="{'opacity-50 cursor-not-allowed': isRedirecting}"
           v-if="isRedirecting"

           >
            <span>{{ waitingTitle}}</span>
        </button>
        <a
            class="py-2 px-2 w-full text-sm text-white rounded bg-orange-500 hover:bg-orange-600 md:text-base lg:text-lg block text-center"
            :href="overviewPageLink"
            v-if="!isRedirecting"
        >
            <span>{{ searchTitle }}</span>
        </a>
    </div>
</template>

<script>
export default {
    name: "HomeRegionSelector",
    props:[
        'locale',
        'search-title',
        'waiting-title',
        'placeholder-text',
        'overview-page-link',
    ],
    data() {
        return {
            isRedirecting: false,
            regions: []
        };
    },
    created() {
        this.getRegions();
    },
    methods: {
        getRegions() {
            axios.get(`/api/regions/${this.locale}`).then((response) => {
                this.regions = response.data;
            });
        },
        redirectToOverview() {
            this.isRedirecting = true;
            window.location = `${this.overviewPageLink}?region=${this.$refs.regionSelector.value}`;
        }

    }
}
</script>

<style scoped>

</style>
